import React, { useState } from 'react';
import { getApiHeader } from 'utlis/commonfunctions';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import axios from 'axios';
import Cube from 'examples/Icons/Cube';
import SimIcon from 'examples/Icons/SimIcon';
import SearchQRModal from './SearchQRModal';
import { toast } from "react-toastify";
import { Rings } from 'react-loader-spinner';
import { Alert, AlertTitle, IconButton } from "@mui/material"; // Import Alert components
import CloseIcon from '@mui/icons-material/Close'; // Import close icon



const SERVER_URL = process.env.REACT_APP_API_URL;


function CommonDownloadQrCode() {
    const [showTable, setShowTable] = useState(false);
    const [activations, setActivations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [dob, setDob] = useState('');
    const [idNumber, setIdNumber] = useState('');
    const [voucherNumber, setVoucherNumber] = useState('');
    const [mobileNumber, setmobileNumber] = useState('');

    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState("");

    const [modalOpen, setModalOpen] = useState(false);
    const [qrData, setQrData] = useState({});

    const handleSubmit = async (event) => {

        event.preventDefault();

        setErrors({});
        setErrorMessage("")

        if (firstName || lastName || dob || idNumber) {
            const newErrors = {};
            if (!firstName) newErrors.firstName = 'First Name is required.';
            if (!lastName) newErrors.lastName = 'Last Name is required.';
            if (!dob) newErrors.dob = 'DOB is required.';
            if (!idNumber) newErrors.idNumber = 'ID Number is required.';

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }
        }
        try {
            setLoading(true)

            const formData = new FormData();
            formData.append('esim_voucher_number', voucherNumber || '');
            formData.append('esim_mobile_number', mobileNumber || '');
            formData.append('first_name', firstName || '');
            formData.append('last_name', lastName || '');
            formData.append('dob', dob || '');
            formData.append('id_number', idNumber || '');
            const headers = await getApiHeader();
            const response = await axios.post(`${SERVER_URL}common-download-esim-qr-code/key-check`, formData, {
                headers: headers
            });

            if (response.status === 200) {
                const responseData = response.data;
                setQrData(responseData.data);
                setModalOpen(true);

            } else {
                console.error('API error:', response.data);
            }
        } catch (error) {
            setErrorMessage(error.response?.data?.message || 'An error occurred. Please try again.');
            console.error('Network or API error:', error.response ? error.response.data : error.message);
        } finally {
            setLoading(false)
        }
    };

    const handleModalClose = () => {
        setModalOpen(false);
    };

    const handleShowTable = async () => {
        setShowTable(true)
        setLoading(true);
        setErrorMessage("")
        try {
            const headers = await getApiHeader();
            const response = await axios({
                method: 'get',
                url: `${SERVER_URL}common-download-esim-qr-code/activations`,
                headers: headers
            });

            if (response.data && response.data.data) {

                setActivations(response.data.data);
            }
        } catch (error) {
            setErrorMessage(error.response?.data?.message || 'An error occurred. Please try again.')
            console.error('Error fetching eSIM activations:', error);
        }
        finally {
            setLoading(false);
        }
    };
    const handleAlertClose = () => {
        setErrorMessage("");
    };

    const scrollToBottom = () => {
        window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth'
        });
    };

    React.useEffect(() => {
        if (errorMessage) {
            scrollToBottom();
        }
    }, [errorMessage]);


  errorMessage&&(
    swal("",errorMessage, 'error').then(()=>{
        setErrorMessage(false)
      })
  )
     

    return (
        <>
            <div>
                <DashboardLayout>
                    <DashboardNavbar />
                    {loading ? (
                        <div className="loader-container">
                            <Rings
                                visible={true}
                                height="500"
                                width="80"
                                color="#c11d6c"
                                ariaLabel="rings-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                            />
                        </div>

                    ) : <div className="container" style={{backgroundColor:"white"}}>
                        <center>
                        <h4 style={{paddingTop:"10px", marginBottom: "-45px" }}>Download eSIM QR Code</h4>
                            <div className="search-details-section">
                                <form onSubmit={handleSubmit} autoComplete='off'>
                                    <div className="form-section ">
                                        <div className="form-group ">
                                            <label htmlFor="esimVoucher" className='download-esim-QrCode-label'>eSIM Voucher Number</label>
                                            <input type="text" className={`form-control ${errors.voucherNumber ? 'is-invalid' : ''}`} id="esimVoucher" value={voucherNumber} onChange={(e) => setVoucherNumber(e.target.value)} autoComplete='off' placeholder="Enter eSIM Voucher Number" />
                                        </div>
                                        <div className="text-center my-2"> <b>OR</b> </div>
                                        <div className="form-group ">
                                            <label htmlFor="mobileNumber" className='download-esim-QrCode-label'  >Mobile Number</label>
                                            <input type="number" className="form-control" id="mobileNumber" value={mobileNumber} onChange={(e) => setmobileNumber(e.target.value)} placeholder="Enter Mobile Number" />
                                        </div>
                                        <div className="text-center my-2"> <b>OR</b> </div>
                                        <div className="form-row row">
                                            <div className="form-group col-md-3">
                                                <label htmlFor="firstName" className='download-esim-QrCode-label'>First Name</label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors.firstName ? 'is-invalid' : ''}`}
                                                    id="firstName"
                                                    placeholder="Enter First Name"
                                                    value={firstName}
                                                    onChange={(e) => setFirstName(e.target.value)}
                                                    autoComplete="new-password"
                                                />
                                                {errors.firstName && <div className="invalid-feedback">{errors.firstName}</div>}
                                            </div>
                                            <div className="form-group col-md-3">
                                                <label htmlFor="lastName" className='download-esim-QrCode-label'>Last Name</label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors.lastName ? 'is-invalid' : ''}`}
                                                    id="lastName"
                                                    placeholder="Enter Last Name"
                                                    value={lastName}
                                                    onChange={(e) => setLastName(e.target.value)}
                                                    autoComplete="new-password"
                                                />
                                                {errors.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
                                            </div>
                                            <div className="form-group col-md-3">
                                                <label htmlFor="dob" className='download-esim-QrCode-label'>DOB</label>
                                                <input
                                                    type="date"
                                                    className={`form-control ${errors.dob ? 'is-invalid' : 'downloadQrcode'} `}
                                                    id="dob"
                                                    value={dob}
                                                    onChange={(e) => setDob(e.target.value)}
                                                    autoComplete="new-password"
                                                />
                                                {errors.dob && <div className="invalid-feedback">{errors.dob}</div>}
                                            </div>
                                            <div className="form-group col-md-3">
                                                <label htmlFor="idNumber" className='download-esim-QrCode-label'>ID Number</label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors.idNumber ? 'is-invalid' : ''}`}
                                                    id="idNumber"
                                                    placeholder="Enter ID Number"
                                                    value={idNumber}
                                                    onChange={(e) => setIdNumber(e.target.value)}
                                                    autoComplete="new-password"
                                                />
                                                {errors.idNumber && <div className="invalid-feedback">{errors.idNumber}</div>}
                                            </div>
                                        </div>

                                        <div className="text-left mt-4">
                                            <button type="submit" className="btn text-white" style={{
                                                padding: '10px 20px',
                                                borderRadius: '5px',
                                                fontSize: '16px',
                                                display: 'inline-block',
                                                textDecoration: 'none',
                                                backgroundColor: '#C11D6C',
                                                border: 'none'
                                            }}>Search</button>
                                        </div>

                                    </div>
                                </form>
                                <div className="text-right mt-3">
                                    <a
                                        href="javascript:;"
                                        className="text-white font-weight-bold"
                                        onClick={handleShowTable}
                                        style={{
                                            padding: '10px 20px',
                                            borderRadius: '5px',
                                            fontSize: '16px',
                                            display: 'inline-block',
                                            textDecoration: 'none',
                                            backgroundColor: '#C11D6C',
                                            border: 'none'
                                        }}
                                        onMouseOver={(e) => (e.target.style.backgroundColor = '#a3165a')}
                                        onMouseOut={(e) => (e.target.style.backgroundColor = '#C11D6C')}
                                    >
                                        <SimIcon size="24px" /> Display Last 10 eSIM Activations
                                    </a>
                                </div>
                                {showTable && (
                                    <div className="mt-4">
                                        <table className="table table-striped">
                                            <thead className="bg-danger text-white">
                                                <tr>
                                                    <th>Sl No.</th>
                                                    <th>First Name</th>
                                                    <th>Last Name</th>
                                                    <th>Mobile Number</th>
                                                    <th>SIM Number</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">
                                                            <div className="spinner-border" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : activations.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">No Data in the list... for now!</td>
                                                    </tr>
                                                ) : (
                                                    activations.map((activation, index) => (
                                                        <tr key={activation.activation_id}>
                                                            <td>{index + 1}</td>
                                                            <td>{activation?.customer.firstName}</td>
                                                            <td>{activation?.customer.surname}</td>
                                                            <td>{activation?.mobile_number}</td>
                                                            <td>{activation.activation_sims?.sim_base?.sim_number || 'N/A'}</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                        <div className="text-left mt-3">
                                            <a
                                                href="javascript:;"
                                                className="text-white font-weight-bold"
                                                onClick={() => setActivations([])}
                                                style={{
                                                    padding: '3px 10px',
                                                    borderRadius: '5px',
                                                    fontSize: '16px',
                                                    display: 'inline-block',
                                                    textDecoration: 'none',
                                                    backgroundColor: '#C11D6C',
                                                    border: 'none'
                                                }}
                                                onMouseOver={(e) => (e.target.style.backgroundColor = '#a3165a')}
                                                onMouseOut={(e) => (e.target.style.backgroundColor = '#C11D6C')}
                                            >
                                                Clear
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </center>

                        {/* {errorMessage && (
                            <Alert
                                severity="error"
                                className="mt-2"
                                action={
                                    <IconButton
                                        aria-label="close"
                                        color="inherit"
                                        onClick={handleAlertClose}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                }
                            >
                                <AlertTitle>Error</AlertTitle>
                                {errorMessage}
                            </Alert>
                        )} */}



                    </div>}

                </DashboardLayout>
            </div>
            <SearchQRModal open={modalOpen} onClose={handleModalClose} data={qrData} />

        </>
    );
}

export default CommonDownloadQrCode;
